import { useEffect } from 'react'
import axios from 'axios'
import oktaAuth from '../oktaAuth.ts'
import { useSessionTimeout } from './SessionTimeoutContext.tsx';

export function useHttpInterceptor() {
  const { openTimeoutModal } = useSessionTimeout()

  useEffect(() => {
    const reqId = axios.interceptors.request.use(
      async (config) => {
        // Attach tokens based on route
        if (window.location.pathname.includes('/public')) {
          // Do not attach for token-fetch request
          if (config.url?.includes('getToken')) return config
          const token = localStorage.getItem('application-token')
          if (token) config.headers.Authorization = `Bearer ${token}`
        } else {
          const oktaToken = JSON.parse(localStorage.getItem('okta-token-storage') || '{}')
            ?.accessToken?.accessToken
          if (!config.url?.endsWith('/health') && oktaToken) {
            config.headers.Authorization = `Bearer ${oktaToken}`
          }
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    const resId = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (!error.response) return Promise.reject(error)
        const status = error.response.status
        const originalConfig = error.config

        const currentPath = window.location.pathname
        if (currentPath === '/login' || currentPath === '/authenticate') {
          return Promise.reject(error)
        }

        if (status === 403) {
          await oktaAuth.signOut()
          window.location.replace('/login')
          return Promise.reject(error)
        }

        if (status === 401) {
          // Prevent retry loops and immediately show single-button modal
          if (originalConfig._retry) {
            window.location.replace('/login')
            return Promise.reject(error)
          }
          originalConfig._retry = true

          // Show the single-button modal
          if(localStorage.getItem("logout") === "true"){
            window.location.replace('/login')
          }else {
            openTimeoutModal()
          }

          // Reject so callers see the failure; we do not retry
          return Promise.reject(error)
        }

        return Promise.reject(error)
      }
    )

    return () => {
      axios.interceptors.request.eject(reqId)
      axios.interceptors.response.eject(resId)
    }
  }, [openTimeoutModal])
}
